// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2jIKs","options":"AnswerScale_options__3ySOs","selected":"AnswerScale_selected__1m6XR"};